import React, { useState, useEffect } from "react";
import { TextField, Grid, Button, Autocomplete } from "@mui/material";
import Layout from "../components/Layout";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../config/firebaseConfig";
import { addDoc, collection, serverTimestamp } from "@firebase/firestore";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { styled } from "@mui/material/styles";
import Success from "../Common/Success";
import { brandName, modelName } from "./fakeData";
import Dropzone from "react-dropzone";

const Input = styled("input")({
  display: "none",
});

const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [name, setName] = useState("");
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [fuelType, setFuelType] = useState("");
  const [gasoline, setGasoline] = useState("");
  const [transmission, setTransmission] = useState("");
  const [engine, setEngine] = useState("");
  const [mileage, setMileage] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState(0);
  const [files, setFiles] = useState([]);
  const [uploadFiles, setFeatureFiles] = useState([]);
  const [email, setEmail] = useState("");
  const [featureImage, setFeatureImage] = useState("");
  const [success] = useState(false);
  const [file, setFile] = useState([]);

  const handleUploadImages = (images) => {
    const uploads = images?.map((file) => {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "x5p3mhti");
      formData.append("timestamp", (Date.now() / 1000) | 0);
      const URL = `https://api.cloudinary.com/v1_1/anik19/image/upload`;
      return axios.post(URL, formData).then((response) => {
        const { data } = response;
        const fileURL = data.secure_url;
        setFile((preFile) => [...preFile, fileURL]);
      });
    });
    Promise.all(uploads).then(() => {
      console.log("upload completed ");
    });
  };

  useEffect(
    () =>
      onAuthStateChanged(auth, (user) => {
        if (user) {
          setUser({
            name: user.displayName,
            email: user.email,
            photoUrl: user.photoURL,
          });
        }
      }),
    []
  );
  // alert("Please upload the feature image")
  const uploadPost = async (e) => {
    e.preventDefault();

    if (loading) return;
    setLoading(true);

    // const docRef = await addDoc(collection(db, "carPost"), {
    await addDoc(collection(db, "carPost"), {
      name: user?.name ? user.name : name,
      email: user?.email ? user?.email : email,
      avatar: user?.photoUrl,
      description: description,
      brand: brand,
      model: model,
      fuelType: fuelType,
      gasoline: gasoline,
      transmission: transmission,
      engine: engine,
      mileage: mileage,
      price: price,
      featureImage: file,
      featureLink: file,
      timestamp: serverTimestamp(),
    });

    setName("");
    setBrand("");
    setPrice("");
    setModel("");
    setFuelType("");
    setGasoline("");
    setTransmission("");
    setEngine("");
    setMileage("");
    setDescription("");
    setLoading(false);
    setFiles("");
    setFeatureFiles("");
    setFeatureImage("");
    setEmail("");
    // window.location.reload(false);
  };

  return (
    <Layout>
      {success && <Success msg="Product created successfully" />}
      <div className="dashboard-layout">
        <Sidebar />
        <>
          <div style={{ marginTop: "20px" }}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              alignContent="center"
            >
              <Grid container spacing={2} item lg={6} sm={10} md={6} xs={12}>
                <Grid item xs={12}>
                  <Dropzone onDrop={handleUploadImages}>
                    {({ getRootProps, getInputProps }) => (
                      <div
                        className="container image_contaner"
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          {...getRootProps({
                            className: "dropzone",
                            onDrop: (event) => event.stopPropagation(),
                          })}
                        >
                          <input {...getInputProps()} />
                          <p>
                            Drag 'n' drop some files here, or click to select
                            files
                          </p>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                  <Grid container xs={12} style={{ marginTop: "15px" }}>
                    {file?.map((image, i) => (
                      <Grid item sm={4} md={3} xs={6} key={i}>
                        <img
                          src={image}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "5px",
                            borderColor: "2px solid #919eab",
                            padding: "2px",
                          }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="email"
                    placeholder="email"
                    variant="standard"
                    style={{ width: "100%" }}
                    type="email"
                    required
                    value={user?.email ? user.email : email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    required
                    id="name"
                    placeholder="name"
                    onChange={(e) => setName(e.target.value)}
                    variant="standard"
                    style={{ width: "100%" }}
                    value={user?.name ? user.name : name}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    required
                    id="brand"
                    placeholder="Brand"
                    label="Brand"
                    variant="standard"
                    style={{ width: "100%" }}
                    onChange={(e) => setBrand(e.target.value)}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    required
                    id="model"
                    placeholder="Model"
                    label="Model"
                    variant="standard"
                    style={{ width: "100%" }}
                    onChange={(e) => setModel(e.target.value)}
                  />
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    id="price"
                    placeholder="Price"
                    label="Price"
                    variant="standard"
                    style={{ width: "100%" }}
                    type="number"
                    required
                    value={user?.price}
                    onChange={(e) => setPrice(e.target.value)}
                  />
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    required
                    id="fuel"
                    placeholder="Fuel type"
                    label="Fuel type"
                    variant="standard"
                    style={{ width: "100%" }}
                    onChange={(e) => setFuelType(e.target.value)}
                  />
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    required
                    id="gasoline"
                    placeholder="Gasoline"
                    label="Gasoline"
                    variant="standard"
                    style={{ width: "100%" }}
                    onChange={(e) => setGasoline(e.target.value)}
                  />
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    required
                    id="Transmission"
                    placeholder="Transmission"
                    label="Transmission"
                    variant="standard"
                    style={{ width: "100%" }}
                    onChange={(e) => setTransmission(e.target.value)}
                  />
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    required
                    id="Engine"
                    placeholder="Engine"
                    label="Engine"
                    variant="standard"
                    style={{ width: "100%" }}
                    onChange={(e) => setEngine(e.target.value)}
                  />
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    required
                    id="Mileage"
                    placeholder="Mileage"
                    label="Mileage"
                    variant="standard"
                    style={{ width: "100%" }}
                    onChange={(e) => setMileage(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    required
                    id="Description"
                    placeholder="Description"
                    label="Description"
                    variant="standard"
                    style={{ width: "100%" }}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Button
              style={{
                display: "block",
                width: "30%",
                margin: "30px auto",
              }}
              variant="contained"
              type="submit"
              disabled={loading}
              onClick={uploadPost}
            >
              SUBMIT
            </Button>
          </div>
        </>
      </div>
    </Layout>
  );
};

export default Dashboard;
